import APIService from './index';

class ManagerService extends APIService {
  getBusinessList() {
    return this.get('/admin/business/connect');
  }

  connect(businessId: string) {
    return this.post('/admin/business/connect', {
      businessId
    });
  }

  checkInvite(code: string) {
    return this.get(`/manager-invite/check/${code}`);
  }

  acceptInvite(code: string) {
    return this.put(`/admin/manager-invite/${code}`);
  }

  sendInvitation(data: { mail: string }) {
    return this.post(`/admin/manager-invite`, data);
  }

  removeInvitation(invite: string) {
    return this.delete(`/admin/manager-invite/${invite}`);
  }

  removeManager(data: { manager: string; business: string }) {
    return this.delete('/manager', data);
  }

  transferOwnership(data: { manager: string }) {
    return this.post('/manager/transfer-ownership', data);
  }

  changePassword(data: {
    code: string;
    newPassword: string;
    withCoins?: boolean;
  }) {
    return this.put('/manager/password', data);
  }

  getTeamMembers(
    sortField?: string,
    sortOrder?: string,
    pagination?: string,
    filters?: string
  ): Promise<any> {
    const resource = this.generateResource(
      '/admin/business/manager?',
      sortField || '',
      sortOrder,
      pagination,
      filters
    );

    return this.get(resource);
  }

  async changeBusiness(businessId: string) {
    const { data, status } = await this.connect(businessId);
    if (status === 201) {
      const { access_token } = data;
      this.setCredentials(access_token);
    }
  }

  getBusinessInfo(code: string) {
    return this.get(`/business/info?code=${code}`);
  }

  dismissOnboardingCallBanner() {
    return this.put('/onboarding-meeting/dismiss-banner');
  }

  acceptClaimAccountHubspotIntegration(data: { code: string }) {
    return this.post('/hubspot-integration/claim-account', data);
  }

  scheduleCallIframeHubspotIntegration(params: any) {
    return this.get('/hubspot-integration/schedule-call', {
      params
    });
  }
}

export default ManagerService;
